import { DefaultRootState } from '@/store/coreReducer.ts'
import { createAsyncThunk } from '@reduxjs/toolkit'
import {logout} from "@/services/PhoenixService.ts";
import DEFAULTS from "@/defaults.ts";

const setLoggedOut = createAsyncThunk<boolean, undefined, { state: DefaultRootState }>('auth:user/logout', async _ => {
	// TODO: do a call to the backend to remove the cookie.
	// TODO: redirect back to the auth system interface.,=
	await logout()

	window.location.href = `${DEFAULTS.LoginURL}/app`

	return true;
})

export { setLoggedOut }
